import { render, staticRenderFns } from "./SolicitudesPendientes.vue?vue&type=template&id=bd0d85c8&"
import script from "./SolicitudesPendientes.vue?vue&type=script&lang=js&"
export * from "./SolicitudesPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports